// extracted by mini-css-extract-plugin
export default {"TextArea":"TextArea_TextArea__i-SDh","TextArea--error":"TextArea_TextArea--error__fcFvm"};